module.exports = __webpack_public_path__ + "static/GorditaMedium-06e85c4f4e96cd01c121d16c7e96bc5f.otf";